import { IconExternalLink } from '@xing-com/icons';

import { Styled } from './formatted-link.styles';

export type FormattedLinkType = {
  text: string;
  href: string;
  urlWithTracking?: string;
  index: number;
  isExternal?: boolean;
};

export const FormattedLink: React.FC<FormattedLinkType> = ({
  text,
  href,
  urlWithTracking,
  index,
  isExternal = false,
}) => {
  const handleAnchorClick = (e: React.MouseEvent): void => {
    e.preventDefault();

    window.location.assign(urlWithTracking || href);
  };

  return (
    <Styled.Link
      {...{ href, fontWeight: 'regular' }}
      {...(isExternal && { target: '_blank' })}
      isFirstLink={index === 0}
      onClick={handleAnchorClick}
    >
      <Styled.BodyCopy size="small">{text}</Styled.BodyCopy>
      {isExternal && <IconExternalLink height={18} width={18} />}
    </Styled.Link>
  );
};
